'use client';

var handleActiveItem = function (selectedDates, date) {
    var _a, _b;
    var isSelectedStart = selectedDates && selectedDates.length > 0;
    var isSelectedEnd = selectedDates && selectedDates.length > 1;
    var isActiveStart = isSelectedStart && date.toDateString() === ((_a = selectedDates[0]) === null || _a === void 0 ? void 0 : _a.toDateString());
    var isActiveEnd = isSelectedEnd && date.toDateString() === ((_b = selectedDates[1]) === null || _b === void 0 ? void 0 : _b.toDateString());
    var isInRangeActive = null;
    if (isSelectedStart && isSelectedEnd) {
        isInRangeActive = selectedDates[0] < date && date < selectedDates[1];
    }
    return { isActiveStart: isActiveStart, isActiveEnd: isActiveEnd, isInRangeActive: isInRangeActive };
};
var getFullYear = function (date) {
    try {
        return date.getFullYear();
    }
    catch (error) {
        throw Error('Invalid Date when get year');
    }
};
var getMonth = function (date) {
    try {
        return date.getMonth();
    }
    catch (error) {
        throw Error('Invalid Date when get month');
    }
};
var getDate = function (date) {
    try {
        return date.getDate();
    }
    catch (error) {
        throw Error('Invalid Date when get date');
    }
};
var getDay = function (date) {
    try {
        return date.getDay();
    }
    catch (error) {
        throw Error('Invalid Date when get day');
    }
};
var getNewDate = function (date, type) {
    try {
        return new Date(getFullYear(date), getMonth(date), getDate(date));
    }
    catch (error) {
        throw Error('Invalid date');
    }
};

export { getDate, getDay, getFullYear, getMonth, getNewDate, handleActiveItem };
//# sourceMappingURL=calendar.js.map
